import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { END_POINT } from '../config';

export default function UserManagement() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: 'contains' }
    });
    const [addDialogVisible, setAddDialogVisible] = useState(false);
    const [modifyDialogVisible, setModifyDialogVisible] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        id: '',
        Title: '',
        field_2: '',
        field_3: '',
        field_4: ''
    });
    const toast = React.useRef(null);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetch(`${END_POINT}getlist`);
                if (!response.ok) {
                    throw new Error('Failed to fetch items');
                }
                const data = await response.json();
                setItems(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching items:', error);
                setLoading(false);
            }
        };

        fetchItems();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <h5 className="m-0">List of Users</h5>
                <div className="flex align-items-center">
                    <Button label="Add" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={() => setAddDialogVisible(true)} />
                    {/* <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" />
                    </span> */}
                </div>
            </div>
        );
    };

    const handleAddSubmit = async () => {
        try {
            const response = await fetch(`${END_POINT}additem`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                const newItem = await response.json();
                setItems([...items, newItem]);
                setAddDialogVisible(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Item added successfully' });
            } else {
                throw new Error('Failed to add item');
            }
        } catch (error) {
            console.error('Error adding item:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add item' });
        }
    };

    const handleModifySubmit = async () => {
        try {
            const { id, ...restFormData } = formData;
            const response = await fetch(`${END_POINT}updateitem/${currentItem.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(restFormData)
            });

            if (response.ok) {
                const updatedItem = await response.json();
                setItems(items.map(item => item.id === updatedItem.id ? updatedItem : item));
                setModifyDialogVisible(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Item updated successfully' });
            } else {
                throw new Error('Failed to update item');
            }
        } catch (error) {
            console.error('Error updating item:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update item' });
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`${END_POINT}deleteitem/${id}`, {
                method: 'DELETE'
            });

            if (response.ok) {
                setItems(items.filter(item => item.id !== id));
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Item deleted successfully' });
            } else {
                throw new Error('Failed to delete item');
            }
        } catch (error) {
            console.error('Error deleting item:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete item' });
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button label="Modify" className="p-button-warning p-mr-2" onClick={() => { setCurrentItem(rowData); setFormData(rowData); setModifyDialogVisible(true); }} />
                <Button label="Delete" className="p-button-danger" onClick={() => confirmDialog({
                    message: 'Are you sure you want to delete this item?',
                    header: 'Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => handleDelete(rowData.id)
                })} />
            </div>
        );
    };

    const header = renderHeader();

    return (
        <div  className="card">
            <Toast ref={toast} />
            <div className="card">
                <DataTable value={items} paginator rows={10} dataKey="id"  loading={loading} header={header} emptyMessage="No items found.">
                    <Column field="id" header="ID"  style={{ minWidth: '12rem' }} />
                    <Column field="Title" header="FirstName"  style={{ minWidth: '12rem' }} />
                    <Column field="field_2" header="LastName"  style={{ minWidth: '12rem' }} />
                    <Column field="field_3" header="UserName" style={{ minWidth: '12rem' }} />
                    <Column field="field_4" header="EmailID"  style={{ minWidth: '12rem' }} />
                    
                    <Column body={actionBodyTemplate} header="Actions" style={{ minWidth: '12rem' }} />
                </DataTable>
            </div>

            <Dialog header="Add Item" visible={addDialogVisible} style={{ width: '450px' }}  footer={<Button label="Submit" icon="pi pi-check" onClick={handleAddSubmit} />} onHide={() => setAddDialogVisible(false)}>
            
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="Title">FirstName</label>
                    <InputText id="Title" value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })} required autoFocus />
                </div>
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="field_2">LastName</label>
                    <InputText id="field_2" value={formData.field_2} onChange={(e) => setFormData({ ...formData, field_2: e.target.value })} required />
                </div>
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="field_3">UserName</label>
                    <InputText id="field_3" value={formData.field_3} onChange={(e) => setFormData({ ...formData, field_3: e.target.value })} required />
                </div>
                <div className="flex flex-row gap-8">
                    <label htmlFor="field_4">EmailID</label>
                    <InputText id="field_4" value={formData.field_4} onChange={(e) => setFormData({ ...formData, field_4: e.target.value })} required />
                </div>
                
            </Dialog>

            <Dialog header="Modify Item" visible={modifyDialogVisible} style={{ width: '450px' }} footer={<Button label="Submit" icon="pi pi-check" onClick={handleModifySubmit} />} onHide={() => setModifyDialogVisible(false)}>
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="Title">FirstName</label>
                    <InputText id="Title" value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })} required autoFocus />
                </div>
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="field_2">LastName</label>
                    <InputText id="field_2" value={formData.field_2} onChange={(e) => setFormData({ ...formData, field_2: e.target.value })} required />
                </div>
                <div className="flex flex-row gap-6 padding-bottom-20">
                    <label htmlFor="field_3">UserName</label>
                    <InputText id="field_3" value={formData.field_3} onChange={(e) => setFormData({ ...formData, field_3: e.target.value })} required />
                </div>
                <div className="flex flex-row gap-8 padding-bottom-20">
                    <label htmlFor="field_4">EmailID</label>
                    <InputText id="field_4" value={formData.field_4} onChange={(e) => setFormData({ ...formData, field_4: e.target.value })} required />
                </div>
               
            </Dialog>

            <ConfirmDialog />
        </div>
    );
}
